/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
// eslint-disable-next-line import/order
import { Wrapper } from "./style";
import { CircularProgress } from "@mui/material";
import { useRouter } from "next/router";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Button } from "components/button";
import { CustomInput } from "components/custom-input";
import { Input } from "components/input";
import { SelectInput } from "components/select";
import { campaignTypes, productTypes, interval } from "../signup.utils";
import { campaignStepOneSchema } from "./input-validations";

export type StepOneCamForm = {
   campaign_name: string;
   campaign_type: string;
   url: string;
   enable_recurring: string;
   currency: string;
   interval: string;
   trial_period: number;
};

const Step3 = () => {
   const router = useRouter();
   const query = router.query;
   const [camOneData, setCamOneData] = useState<StepOneCamForm>();

   const [campaignName, setCampaignName] = useState("");
   const [campaignType, setCampaignType] = useState("single_access");
   const [campaignUrl, setCampaignUrl] = useState("");
   const [productType, setProductType] = useState("E-commerce");
   const [currency, setCurrency] = useState("");
   const [intervalData, setInterval] = useState("");
   const [trialPeriod, setTrialPeriod] = useState(0);

   useEffect(() => {
      if (query.apiKey) {
         localStorage.setItem("token", `${query.apiKey}`);
      }
   }, [query.apiKey]);
   const [isLoading, setIsLoading] = useState(false);
   // const [shop, setShop] = useState("");
   let shop;
   if (typeof window !== "undefined") {
      shop = localStorage.getItem("shop");
      console.log(shop, "shop");
   }
   const {
      register,
      handleSubmit,
      formState: { errors },
      watch,
      control,
   } = useForm<StepOneCamForm>({
      resolver: yupResolver(campaignStepOneSchema),
   });
   const [errorData, setErrorData] = useState("");
   function validURL(str) {
      var pattern = new RegExp(
         "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
         "i"
      ); // fragment locator
      return !!pattern.test(str);
   }
   const [campaignNameError, setCampaignNameError] = useState("");
   const [campaignTypeError, setCampaignTypeError] = useState("");
   const [campaignUrlError, setCampaignUrlError] = useState("");
   const [productTypeError, setProductTypeError] = useState("");
   const [currencyError, setCurrencyError] = useState("");
   const [intervalDataError, setIntervalError] = useState("");
   const [trialPeriodError, setTrialPeriodError] = useState("");

   function handleSubmitData(e: React.ChangeEvent<any>) {
      e.preventDefault();
      if (!campaignName) {
         setCampaignNameError("Please fill this field");
      }
      if (!campaignType) {
         setCampaignTypeError("Please fill this field");
      }
      if (!campaignUrl) {
         setCampaignUrlError("Please fill this field");
      }
      if (!productType) {
         setProductTypeError("Please fill this field");
      }
      if (!currency) {
         setCurrencyError("Please fill this field");
      }
      if (productType === "saas") {
         if (!intervalData) {
            setIntervalError("Please fill this field");
         }
         if (!trialPeriod || trialPeriod === 0) {
            setTrialPeriodError("This field must be greater than zero");
         }
      }

      let data = {
         campaign_name: campaignName,
         campaign_type: campaignType,
         url: campaignUrl,
         enable_recurring: productType,
         currency: currency,
         interval: intervalData,
         trial_period: Number(trialPeriod),
      };
      if (
         data.campaign_name &&
         data.campaign_type &&
         data.url &&
         data.enable_recurring &&
         data.currency
      ) {
         if (data.enable_recurring === "saas") {
            if (data.interval && data.trial_period! > 0) {
               console.log(data, "nothere");
               proceed(data);
            }
         } else {
            let result = {
               campaign_name: campaignName,
               campaign_type: campaignType,
               url: campaignUrl,
               enable_recurring: productType,
               currency: currency,
            };
            console.log(result, "here");
            proceed(result);
         }
      } else {
      }

      // if (!data.interval) {
      //    setErrorData("true");
      // } else {
      //    if (!validURL(data.url)) {
      //       setIsLoading(false);
      //       Swal.fire({
      //          icon: "error",
      //          title: "Oops...",
      //          text: "Invalid Landing Page url",
      //       });
      //    } else {
      //       localStorage.setItem("cam_one", JSON.stringify(data));
      //       router.push("/signup/step-4");
      //    }
      // }
   }
   function proceed(data) {
      console.log("data");
      if (!validURL(data.url)) {
         setIsLoading(false);
         Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Invalid Landing Page url",
         });
      } else {
         localStorage.setItem("cam_one", JSON.stringify(data));
         router.push("/signup/step-4");
      }
   }
   // campaign_name: "praisepapi24535345";
   // campaign_type: "single_access";
   // currency: "USD";
   // enable_recurring: "saas";
   // interval: "weekly";
   // trial_period: 2;
   // url: "paddles-website.com";
   const allCountries = [
      { value: "USD", label: "USD-$" },
      { value: "GBP", label: "GBP-£" },
      { value: "EUR", label: "EUR-€" },
      { value: "AUD", label: "AUD-$" },
      { value: "BRL", label: "BRL-R$" },
      { value: "CAD", label: "CAD-$" },
      { value: "CNY", label: "CNY-¥" },
      { value: "CZK", label: "CZK-Kč" },
      { value: "DKK", label: "DKK-Kr." },
      { value: "HKD", label: "HKD-$" },
      { value: "HUF", label: "HUF-Ft" },
      { value: "ILS", label: "ILS-₪" },
      { value: "JPY", label: "JPY-¥" },
      { value: "MYR", label: "MYR-$" },
      { value: "MXN", label: "MXN-£" },
      { value: "TWD", label: "TWD-$" },
      { value: "NZD", label: "NZD-$" },
      { value: "MOK", label: "MOK-kr" },
      { value: "PHP", label: "PHP-₱" },
      { value: "PLN", label: "PLN-zł" },
      { value: "RUB", label: "RUB-₽" },
      { value: "SGD", label: "SGD-$" },
      { value: "SEK", label: "SEK-kr" },
      { value: "CHF", label: "CHF-CHf" },
      { value: "THB", label: "THB-฿" },
   ];
   useEffect(() => {
      const ISSERVER = typeof window === "undefined";
      !ISSERVER && setCamOneData(JSON.parse(localStorage.getItem("cam_one") || "{}"));
   }, []);
   const [fullLoading, setFullLoading] = useState(true);

   useEffect(() => {
      let dataShop = localStorage.getItem("shop");
      if (camOneData) {
         setFullLoading(false);
         setCampaignName(camOneData.campaign_name);
         if (dataShop) {
            setCampaignUrl(dataShop);
         } else {
            setCampaignUrl(camOneData.url);
         }
         setTrialPeriod(camOneData.trial_period);
      }
   }, [camOneData]);
   const showTrialError = (error) => {
      if (errors.trial_period?.message === "trial_period must be greater than or equal to 1") {
         return "Trial period must be greater than 0";
      } else if (errors.trial_period?.message) {
         return "Please fill this field";
      } else {
         return "";
      }
   };
   return fullLoading ? (
      <CircularProgress />
   ) : (
      <Wrapper>
         <div className="text-block">
            <div className="base">
               <small>STEP 2 OF 3</small>
               <p>Brand Marketing Info</p>
            </div>
            <div className="info">
               <h2>Now, setup your brand new affiliate program!</h2>
               <p>Let’s supercharge your affiliate marketing campaigns!.</p>
            </div>
         </div>

         <form onSubmit={handleSubmitData}>
            <Input
               endAdornment
               label="Campaign name"
               id="cmpname"
               placeholder="This is the name of your affiliate program"
               defaultValue={
                  camOneData?.campaign_name === ""
                     ? watch("campaign_name")
                     : camOneData?.campaign_name
               }
               onChange={(data: any) => {
                  setCampaignName(data.target.value);
               }}
            />
            {!campaignName && <p className="error">{campaignNameError}</p>}
            <Controller
               control={control}
               name="campaign_type"
               render={({ field: { onChange } }) => (
                  <>
                     <SelectInput
                        label="Campaign type"
                        placeholder="Select Campaign Type"
                        onChange={(data: any) => {
                           onChange(data?.value);
                           setCampaignType(data?.value);
                        }}
                        required={true}
                        tag={
                           campaignType == "single_access" ? (
                              <div>
                                 This option limits your affiliates to one active affiliate program
                                 per sign-up. Read more{" "}
                                 <a
                                    target="_blank"
                                    href="https://metricks.freshdesk.com/support/solutions/articles/73000541582-campaign-type-single-access-sac-"
                                    rel="noreferrer"
                                 >
                                    here
                                 </a>
                                 .
                              </div>
                           ) : (
                              <div>
                                 This option enables your affiliates to access all your campaigns
                                 with one unique sign up. Read more{" "}
                                 <a
                                    target="_blank"
                                    href="https://metricks.freshdesk.com/support/solutions/articles/73000543243-campaign-type-multiple-access-mac-"
                                    rel="noreferrer"
                                 >
                                    here
                                 </a>
                                 .
                              </div>
                           )
                        }
                        error={errors.campaign_type?.message}
                        options={campaignTypes}
                        defaultValue={campaignTypes[0]}
                     />
                  </>
               )}
            />
            {!campaignType && <p className="error">{campaignTypeError}</p>}
            {shop && (
               <>
                  <CustomInput
                     type="text"
                     id="url"
                     tag="This is a URL where all your afffiliates activities woulld bring traffic to. You can also add more URLs and allocate them to different locations"
                     label="Landing page URL"
                     error={errors.url?.message}
                     defaultValue={shop.split("https://")[1]}
                     onChange={(data: any) => {
                        setCampaignUrl(shop);
                     }}
                     notAurl={true}
                     disabled={true}
                  />
                  <div className="hidden">
                     <CustomInput
                        type="text"
                        id="url"
                        tag="This is a URL where alll your afffiliates activities woulld bring traffic to. You can also add more URLs and allocate them to different locations"
                        label="Landing page URL"
                        error={errors.url?.message}
                        defaultValue={shop}
                        notAurl={true}
                        onChange={(data: any) => {
                           setCampaignUrl(shop);
                        }}
                     />
                  </div>
               </>
            )}
            {/* {!campaignUrl && <p className="error">{campaignUrlError}</p>} */}
            {!shop && (
               <CustomInput
                  type="text"
                  id="url"
                  tag="This is a URL where alll your afffiliates activities woulld bring traffic to. You can also add more URLs and allocate them to different locations"
                  label="Landing page URL"
                  error={errors.url?.message}
                  defaultValue={camOneData?.url === "" ? watch("url") : camOneData?.url}
                  notAurl={true}
                  onChange={(data: any) => {
                     setCampaignUrl(data.target.value);
                  }}
               />
            )}
            {!campaignUrl && <p className="error">{campaignUrlError}</p>}
            <Controller
               control={control}
               name="enable_recurring"
               render={({ field: { onChange } }) => (
                  <>
                     <SelectInput
                        label="Product"
                        placeholder="Select Product"
                        onChange={(data: any) => {
                           setProductType(data?.value);
                           onChange(data?.value);
                        }}
                        isSearchable={false}
                        required={true}
                        error={errors.enable_recurring?.message}
                        options={productTypes}
                        defaultValue={productTypes[1]}
                     />
                  </>
               )}
            />
            {!productType && <p className="error">{productTypeError}</p>}

            <Controller
               control={control}
               name="currency"
               render={({ field: { onChange } }) => (
                  <>
                     <SelectInput
                        label="Currency"
                        placeholder="Select Currency"
                        tag="Your affilaites would be paid in this currency"
                        onChange={(data: any) => {
                           setCurrency(data?.value);
                           onChange(data?.value);
                           localStorage.setItem("symbol", data?.label);
                        }}
                        required={true}
                        error={errors.currency?.message}
                        options={allCountries}
                     />
                  </>
               )}
            />
            {!currency && <p className="error">{currencyError}</p>}
            {watch("enable_recurring") === "saas" && (
               <>
                  <CustomInput
                     type="text"
                     id="trial"
                     custom={true}
                     customText="days"
                     label="Product Trial Period"
                     error={showTrialError(errors)}
                     notAurl={true}
                     defaultValue={
                        camOneData?.trial_period === 0
                           ? watch("trial_period")
                           : camOneData?.trial_period
                     }
                     onChange={(data: any) => {
                        setTrialPeriod(data.target.value);
                     }}
                     // {...register("trial_period")}
                  />
                  {!trialPeriod && <p className="error">{trialPeriodError}</p>}
               </>
            )}
            {/* data */}
            {watch("enable_recurring") === "saas" && (
               <>
                  <Controller
                     control={control}
                     name="interval"
                     render={({ field: { onChange } }) => (
                        <>
                           <SelectInput
                              label="Subscription Interval"
                              placeholder="Select Subscription Interval"
                              onChange={(data: any) => {
                                 setInterval(data?.value);
                                 onChange(data?.value);
                              }}
                              required={true}
                              tag="How do users subscribe for your product? Daily, Weekly, Monthly, or Yearly"
                              error={errorData == "true" ? "Please fill the field" : ""}
                              options={interval}
                           />
                        </>
                     )}
                  />
                  {!intervalData && <p className="error">{intervalDataError}</p>}
               </>
            )}
            <Button
               type="submit"
               variant="primary"
               className="ripple"
               fullWidth={true}
               isLoading={isLoading}
               style={{ fontSize: 16, fontWeight: 500 }}
            >
               {isLoading ? "loading...." : "CONTINUE"}
            </Button>
         </form>
      </Wrapper>
   );
};

export { Step3 };
